var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 38 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.454 3.15C14.202-.997 7.394-.968 3.182 3.244c-4.212 4.212-4.241 11.02-.094 15.272l7.564 7.564 15.373-15.373-7.564-7.564-.007.007Z",
  fill: "#8486EC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m18.463 3.244 15.373 15.373c4.244-4.245 4.244-11.129 0-15.373-4.245-4.245-11.128-4.245-15.373 0Z",
  fill: "#FF9776"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.956 10.748 10.631 26.073l7.866 7.867 15.325-15.325-7.866-7.867Z",
  fill: "#397FC0"
})));
export default SvgHeart;